import { useMediaQuery } from 'react-responsive';
import { ScreenSize } from './ScreenSize';

export const GetScreenSize = () => {
    const isDesktop = useMediaQuery({ query: '(min-width: 1200px)' });
    const isTablet = useMediaQuery({ query: '(min-width: 768px)' });

    if (isDesktop) {
        return ScreenSize.Desktop;
    }

    if (isTablet) {
        return ScreenSize.Tablet;
    }

    return ScreenSize.Mobile;
}